import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, unref as _unref, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "px-4 py-16 sm:px-6 lg:flex-auto lg:px-0 lg:py-12" }
const _hoisted_2 = { class: "mx-auto max-w-2xl space-y-16 sm:space-y-20 lg:mx-0 lg:max-w-none" }
const _hoisted_3 = { class: "font-semibold text-gray-700 text-3xl capitalize" }
const _hoisted_4 = { class: "text-base font-semibold leading-7 text-gray-900" }
const _hoisted_5 = { class: "mt-1 text-sm leading-6 text-gray-500" }
const _hoisted_6 = { class: "mt-6 space-y-6 divide-y divide-gray-200 border-t border-gray-200 text-sm leading-6" }
const _hoisted_7 = { class: "pt-6 sm:flex" }
const _hoisted_8 = { class: "font-medium text-gray-900 sm:w-64 sm:flex-none sm:pr-6" }
const _hoisted_9 = { class: "mt-1 flex gap-x-6 sm:mt-0 sm:flex-auto max-w-full md:max-w-xl" }
const _hoisted_10 = { class: "pt-6 sm:flex" }
const _hoisted_11 = { class: "font-medium text-gray-900 sm:w-64 sm:flex-none sm:pr-6" }
const _hoisted_12 = { class: "mt-1 flex justify-between gap-x-6 sm:mt-0 sm:flex-auto max-w-xl" }
const _hoisted_13 = { class: "pt-6 sm:flex" }
const _hoisted_14 = { class: "sm:w-64 sm:flex-none sm:pr-6" }
const _hoisted_15 = { class: "font-medium text-gray-900" }
const _hoisted_16 = { class: "text-xs text-gray-600" }
const _hoisted_17 = { class: "mt-1 sm:mt-0 sm:flex-auto max-w-xl" }
const _hoisted_18 = { class: "flex justify-between gap-x-6 sm:flex-auto" }
const _hoisted_19 = ["src", "alt"]
const _hoisted_20 = { class: "flex items-start gap-x-3" }
const _hoisted_21 = {
  key: 0,
  class: "mt-8 flex items-center gap-x-2"
}
const _hoisted_22 = ["src", "alt", "onClick"]
const _hoisted_23 = { class: "pt-6 sm:flex" }
const _hoisted_24 = { class: "font-medium text-gray-900 sm:w-64 sm:flex-none sm:pr-6" }
const _hoisted_25 = { class: "mt-1 flex justify-between gap-x-6 sm:mt-0 sm:flex-auto max-w-xl" }
const _hoisted_26 = { class: "pt-6 sm:flex" }
const _hoisted_27 = { class: "font-medium text-gray-900 sm:w-64 sm:flex-none sm:pr-6" }
const _hoisted_28 = { class: "mt-1 flex justify-between gap-x-6 sm:mt-0 sm:flex-auto max-w-xl" }
const _hoisted_29 = { class: "pt-6 sm:flex" }
const _hoisted_30 = { class: "font-medium text-gray-900 sm:w-64 sm:flex-none sm:pr-6" }
const _hoisted_31 = { class: "mt-1 flex flex-col justify-between gap-x-6 sm:mt-0 sm:flex-auto max-w-xl" }
const _hoisted_32 = { class: "mt-8 w-full flex items-center justify-end gap-x-3" }
const _hoisted_33 = ["disabled"]
const _hoisted_34 = {
  key: 0,
  class: "flex items-center justify-center gap-x-2"
}
const _hoisted_35 = { key: 1 }
const _hoisted_36 = { class: "text-base font-semibold leading-7 text-gray-900" }
const _hoisted_37 = { class: "mt-1 text-sm leading-6 text-gray-500" }
const _hoisted_38 = { class: "mt-6 space-y-6 divide-y divide-gray-200 border-t border-gray-200 text-sm leading-6" }
const _hoisted_39 = { class: "pt-6 sm:flex" }
const _hoisted_40 = { class: "font-medium text-gray-900 sm:w-64 sm:flex-none sm:pr-6" }
const _hoisted_41 = {
  key: 0,
  class: "flex items-center justify-center gap-x-2"
}
const _hoisted_42 = { key: 1 }

import { computed, onMounted, ref } from "vue";
import { useUserStore } from "@/stores/userStore";
import {
  getAuth,
  reauthenticateWithCredential,
  EmailAuthProvider,
} from "firebase/auth";
import i18n from "@/plugins/i18n";

const defaultProfilePic =
  "https://firebasestorage.googleapis.com/v0/b/reflective-learning-prod.appspot.com/o/avatars%2Fv2%2Fdefault-avatar.png?alt=media&token=6cf0f887-e22a-41d1-a797-a723da68cc48";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileView',
  setup(__props) {

const userStore = useUserStore();
const showAvatarEdit = ref(false);
const showUpdatePassword = ref(false);

// Form Inputs
const firstName = ref("");
const lastName = ref("");
const email = ref("");
const designation = ref("");
const linkedin = ref("");
const instagram = ref("");
const newPassword = ref("");
const currentPassword = ref("");
const confirmPassword = ref("");

const selectedAvatar = ref(userStore.getUser?.profilePic || "");
const avatars = ref([
  {
    name: "bird",
    link: "https://firebasestorage.googleapis.com/v0/b/reflective-learning-prod.appspot.com/o/avatars%2Fv2%2Fbirdie-tar.png?alt=media&token=dc8a8946-a7d9-400d-8c5b-b618d31f76b4",
  },
  {
    name: "bunny",
    link: "https://firebasestorage.googleapis.com/v0/b/reflective-learning-prod.appspot.com/o/avatars%2Fv2%2Fbunny-tar.png?alt=media&token=4585ac28-8a36-40c5-9f08-fd5522b944c6",
  },
  {
    name: "fish",
    link: "https://firebasestorage.googleapis.com/v0/b/reflective-learning-prod.appspot.com/o/avatars%2Fv2%2Ffish-tar.png?alt=media&token=1b19270a-510e-4769-a8c2-ae5beb407237",
  },
  {
    name: "cat",
    link: "https://firebasestorage.googleapis.com/v0/b/reflective-learning-prod.appspot.com/o/avatars%2Fv2%2Fmeow-tar.png?alt=media&token=cbe588ea-d47d-41e9-98f9-63bd461d8e2e",
  },
  {
    name: "bunny",
    link: "https://firebasestorage.googleapis.com/v0/b/reflective-learning-prod.appspot.com/o/avatars%2Fv2%2Fpuppy-tar.png?alt=media&token=bfda6bd0-ee3d-4014-90f7-9f6e46a70655",
  },
]);

// Load user data on component mount
onMounted(() => {
  const user = userStore.getUser;
  if (user) {
    firstName.value = user.firstName;
    lastName.value = user.lastName;
    email.value = user.email;
    designation.value = user.designation || "";
    linkedin.value = user.linkedin || "";
    instagram.value = user.instagram || "";
    selectedAvatar.value = user.profilePic || "";
  }
});

const isProfileChanged = computed(() => {
  const user = userStore.getUser;
  if (!user) return false;
  return (
    firstName.value !== user.firstName ||
    lastName.value !== user.lastName ||
    email.value !== user.email ||
    designation.value !== user.designation ||
    linkedin.value !== user.linkedin ||
    instagram.value !== user.instagram ||
    selectedAvatar.value !== user.profilePic
  );
});

const selectAvatar = (avatarLink: string) => {
  selectedAvatar.value = avatarLink;
};

const removeAvatar = () => {
  selectedAvatar.value = defaultProfilePic;
};

const cancelUpdateProfile = async () => {
  const user = userStore.getUser;

  if (user) {
    firstName.value = user.firstName;
    lastName.value = user.lastName;
    email.value = user.email;
    designation.value = user.designation || "";
    linkedin.value = user.linkedin || "";
    instagram.value = user.instagram || "";
  }

  showAvatarEdit.value = false;
};

const updateProfile = async () => {
  const user = userStore.getUser;

  // conditionally add updated fields only to the payload
  const updatedData = {
    ...(firstName.value !== user?.firstName && { firstName: firstName.value }),
    ...(lastName.value !== user?.lastName && { lastName: lastName.value }),
    ...(email.value !== user?.email && { email: email.value }),
    ...(designation.value !== user?.designation && {
      designation: designation.value,
    }),
    ...(linkedin.value !== user?.linkedin && { linkedin: linkedin.value }),
    ...(instagram.value !== user?.instagram && { instagram: instagram.value }),
    ...(selectedAvatar.value !== user?.profilePic && {
      profilePic: selectedAvatar.value,
    }),
  } as any;

  await userStore.updateProfile(updatedData);

  cancelUpdateProfile();
};

const updatePassword = async () => {
  if (newPassword.value !== confirmPassword.value) {
    alert(i18n.global.t("profile_view.confirm_password"));
    return;
  }

  try {
    const auth = getAuth();
    const user = auth.currentUser;
    if (user && user.email) {
      const credential = EmailAuthProvider.credential(
        user.email,
        currentPassword.value
      );
      // Re-authenticate the user
      await reauthenticateWithCredential(user, credential);

      // Update the password
      await userStore.updateProfile({ password: newPassword.value });

      // Reset form fields
      currentPassword.value = "";
      newPassword.value = "";
      confirmPassword.value = "";
      showUpdatePassword.value = false;
    } else {
      alert(i18n.global.t("profile_view.no_user"));
    }
  } catch (error: any) {
    console.error("Error updating password:", error);
    if (error.code === "auth/wrong-password") {
      alert(i18n.global.t("profile_view.incorrect_password"));
    } else if (error.code === "auth/weak-password") {
      alert(i18n.global.t("profile_view.weak_password"));
    } else {
      alert(i18n.global.t("profile_view.failed_update"));
    }
  }
};

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!
  const _component_spinner_loader = _resolveComponent("spinner-loader")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t("profile_view.title")), 1),
      _createElementVNode("div", null, [
        _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$t("profile_view.personal_info")), 1),
        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t("profile_view.update_details")), 1),
        _createElementVNode("dl", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("dt", _hoisted_8, _toDisplayString(_ctx.$t("profile_view.name")), 1),
            _createElementVNode("dd", _hoisted_9, [
              _createVNode(_component_FormKit, {
                modelValue: firstName.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((firstName).value = $event)),
                type: "text",
                name: "firstName",
                "outer-class": "w-full",
                validation: "required",
                "input-class": "w-full h-11 mt-1 border-1 border-gray-300",
                "label-class": "text-black font-semibold",
                placeholder: _ctx.$t('profile_view.name_placeholder'),
                "validation-messages": {
                  required: _ctx.$t('profile_view.input.required'),
                }
              }, null, 8, ["modelValue", "placeholder", "validation-messages"]),
              _createVNode(_component_FormKit, {
                modelValue: lastName.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((lastName).value = $event)),
                type: "text",
                name: "lastName",
                "outer-class": "w-full",
                validation: "required",
                "input-class": "w-full h-11 mt-1 border-1 border-gray-300",
                "label-class": "text-black font-semibold",
                placeholder: _ctx.$t('profile_view.surname_placeholder'),
                "validation-messages": {
                  required: _ctx.$t('profile_view.input.required'),
                }
              }, null, 8, ["modelValue", "placeholder", "validation-messages"])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("dt", _hoisted_11, _toDisplayString(_ctx.$t("profile_view.email")), 1),
            _createElementVNode("dd", _hoisted_12, [
              _createVNode(_component_FormKit, {
                modelValue: email.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((email).value = $event)),
                type: "text",
                name: "email",
                "outer-class": "w-full",
                validation: "required|email",
                "input-class": "w-full h-11 mt-1 border-1 border-gray-300",
                "label-class": "text-black font-semibold",
                placeholder: _ctx.$t('profile_view.email_placeholder'),
                "validation-messages": {
                  required: _ctx.$t('profile_view.input.required'),
                }
              }, null, 8, ["modelValue", "placeholder", "validation-messages"])
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("dt", _hoisted_14, [
              _createElementVNode("h3", _hoisted_15, _toDisplayString(_ctx.$t("profile_view.photo")), 1),
              _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.$t("profile_view.your_profile")), 1)
            ]),
            _createElementVNode("dd", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("img", {
                  class: "inline-block h-14 w-14 rounded-full",
                  src: selectedAvatar.value || defaultProfilePic,
                  alt: _ctx.$t('profile_view.input.profile_alt')
                }, null, 8, _hoisted_19),
                _createElementVNode("div", _hoisted_20, [
                  (!showAvatarEdit.value)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: removeAvatar,
                        type: "button",
                        class: "font-semibold text-gray-800 hover:text-gray-900"
                      }, _toDisplayString(_ctx.$t("profile_view.btn_delete")), 1))
                    : _createCommentVNode("", true),
                  (!showAvatarEdit.value)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (showAvatarEdit.value = true)),
                        type: "button",
                        class: "font-semibold text-blue-600 hover:text-indigo-500"
                      }, _toDisplayString(_ctx.$t("profile_view.btn_update")), 1))
                    : _createCommentVNode("", true),
                  (showAvatarEdit.value)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 2,
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (showAvatarEdit.value = false)),
                        type: "button",
                        class: "font-semibold text-blue-600 hover:text-indigo-500"
                      }, _toDisplayString(_ctx.$t("profile_view.btn_cancel")), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              (showAvatarEdit.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(avatars.value, (avatar, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "relative"
                      }, [
                        _createElementVNode("img", {
                          src: avatar.link,
                          alt: avatar.name,
                          class: _normalizeClass(["h-14 w-14 rounded-full cursor-pointer border-2", 
                      selectedAvatar.value === avatar.link
                        ? 'border-indigo-500'
                        : 'border-transparent'
                    ]),
                          onClick: ($event: any) => (selectAvatar(avatar.link))
                        }, null, 10, _hoisted_22)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("dt", _hoisted_24, _toDisplayString(_ctx.$t("profile_view.designation")), 1),
            _createElementVNode("dd", _hoisted_25, [
              _createVNode(_component_FormKit, {
                modelValue: designation.value,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((designation).value = $event)),
                type: "text",
                name: "designation",
                "outer-class": "w-full",
                validation: "required",
                "input-class": "w-full h-11 mt-1 border-1 border-gray-300",
                "label-class": "text-black font-semibold",
                placeholder: _ctx.$t('profile_view.designation_placeholder'),
                "validation-messages": {
                  required: _ctx.$t('profile_view.input.required'),
                }
              }, null, 8, ["modelValue", "placeholder", "validation-messages"])
            ])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("dt", _hoisted_27, _toDisplayString(_ctx.$t("profile_view.instagram")), 1),
            _createElementVNode("dd", _hoisted_28, [
              _createVNode(_component_FormKit, {
                modelValue: instagram.value,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((instagram).value = $event)),
                type: "text",
                name: "instagram",
                "outer-class": "w-full",
                "input-class": "w-full h-11 mt-1 border-1 border-gray-300",
                "label-class": "text-black font-semibold",
                placeholder: _ctx.$t('profile_view.instagram_placeholder')
              }, null, 8, ["modelValue", "placeholder"])
            ])
          ]),
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("dt", _hoisted_30, _toDisplayString(_ctx.$t("profile_view.linkedIn")), 1),
            _createElementVNode("dd", _hoisted_31, [
              _createVNode(_component_FormKit, {
                modelValue: linkedin.value,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((linkedin).value = $event)),
                type: "text",
                name: "linkedin",
                "outer-class": "w-full",
                "input-class": "w-full h-11 mt-1 border-1 border-gray-300",
                "label-class": "text-black font-semibold",
                placeholder: _ctx.$t('profile_view.linkedIn_placeholder')
              }, null, 8, ["modelValue", "placeholder"]),
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("button", {
                  onClick: cancelUpdateProfile,
                  type: "button",
                  class: "rounded-md bg-white px-2.5 py-1.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                }, _toDisplayString(_ctx.$t("profile_view.btn_cancel")), 1),
                _createElementVNode("button", {
                  onClick: updateProfile,
                  type: "button",
                  disabled: 
                    !isProfileChanged.value || _unref(userStore).loader.updateProfile
                  ,
                  class: "w-fit rounded-md bg-blue-600 px-2.5 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600 disabled:opacity-50"
                }, [
                  (_unref(userStore).loader.updateProfile)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_34, [
                        _createVNode(_component_spinner_loader, { color: 'text-white dark:text-white' }),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t("profile_view.updating")), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString(_ctx.$t("profile_view.save")), 1))
                ], 8, _hoisted_33)
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("h2", _hoisted_36, _toDisplayString(_ctx.$t("profile_view.settings")), 1),
        _createElementVNode("p", _hoisted_37, _toDisplayString(_ctx.$t("profile_view.update_account")), 1),
        _createElementVNode("dl", _hoisted_38, [
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("dt", _hoisted_40, _toDisplayString(_ctx.$t("profile_view.password")), 1),
            _createElementVNode("dd", {
              class: _normalizeClass(["mt-1 flex flex-col justify-between gap-x-6 gap-y-2 sm:mt-0 sm:flex-auto max-w-xl", !showUpdatePassword.value ? 'items-end' : ''])
            }, [
              (!showUpdatePassword.value)
                ? (_openBlock(), _createBlock(_component_FormKit, {
                    key: 0,
                    disabled: "",
                    type: "password",
                    name: "password",
                    value: "password",
                    "outer-class": "w-full",
                    validation: "required|length:6",
                    "input-class": "w-full h-11 mt-1 border-1 border-gray-300",
                    "label-class": "text-black font-semibold",
                    "validation-messages": {
                  required: _ctx.$t('profile_view.input.required'),
                  length: _ctx.$t('profile_view.input.length'),
                }
                  }, null, 8, ["validation-messages"]))
                : _createCommentVNode("", true),
              (!showUpdatePassword.value)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (showUpdatePassword.value = true)),
                    type: "button",
                    class: "-mt-1 font-semibold text-blue-600 hover:text-indigo-500"
                  }, _toDisplayString(_ctx.$t("profile_view.change_password")), 1))
                : _createCommentVNode("", true),
              (showUpdatePassword.value)
                ? (_openBlock(), _createBlock(_component_FormKit, {
                    key: 2,
                    modelValue: currentPassword.value,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((currentPassword).value = $event)),
                    type: "password",
                    name: "currentPassword",
                    "outer-class": "w-full",
                    validation: "required|length:6",
                    "input-class": "w-full h-11 mt-1 border-1 border-gray-300",
                    "label-class": "text-black font-semibold",
                    placeholder: _ctx.$t('profile_view.current_password'),
                    "validation-messages": {
                  required: _ctx.$t('profile_view.input.required'),
                  length: _ctx.$t('profile_view.input.length'),
                }
                  }, null, 8, ["modelValue", "placeholder", "validation-messages"]))
                : _createCommentVNode("", true),
              (showUpdatePassword.value)
                ? (_openBlock(), _createBlock(_component_FormKit, {
                    key: 3,
                    modelValue: newPassword.value,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((newPassword).value = $event)),
                    type: "password",
                    name: "newPassword",
                    "outer-class": "w-full",
                    validation: "required|length:6",
                    "input-class": "w-full h-11 mt-1 border-1 border-gray-300",
                    "label-class": "text-black font-semibold",
                    placeholder: _ctx.$t('profile_view.new_password'),
                    "validation-messages": {
                  required: _ctx.$t('profile_view.input.required'),
                  length: _ctx.$t('profile_view.input.length'),
                }
                  }, null, 8, ["modelValue", "placeholder", "validation-messages"]))
                : _createCommentVNode("", true),
              (showUpdatePassword.value)
                ? (_openBlock(), _createBlock(_component_FormKit, {
                    key: 4,
                    modelValue: confirmPassword.value,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((confirmPassword).value = $event)),
                    type: "password",
                    name: "confirmPassword",
                    "outer-class": "w-full",
                    validation: "required|length:6",
                    "input-class": "w-full h-11 mt-1 border-1 border-gray-300",
                    "label-class": "text-black font-semibold",
                    placeholder: _ctx.$t('profile_view.confirm_new_password'),
                    "validation-messages": {
                  required: _ctx.$t('profile_view.input.required'),
                  length: _ctx.$t('profile_view.input.length'),
                }
                  }, null, 8, ["modelValue", "placeholder", "validation-messages"]))
                : _createCommentVNode("", true),
              (showUpdatePassword.value)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 5,
                    onClick: updatePassword,
                    type: "button",
                    class: "w-fit block mr-0 ml-auto mt-4 rounded-md bg-blue-600 px-2.5 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
                  }, [
                    (_unref(userStore).loader.updateProfile)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_41, [
                          _createVNode(_component_spinner_loader, { color: 'text-white dark:text-white' }),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t("profile_view.updating_password")), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_42, _toDisplayString(_ctx.$t("profile_view.update_password")), 1))
                  ]))
                : _createCommentVNode("", true)
            ], 2)
          ])
        ])
      ])
    ])
  ]))
}
}

})